import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2_title_small" }
const _hoisted_2 = ["onClick"]

import { getNewsContentList } from '@/config/request'
import { ref,toRefs } from 'vue'
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'dynamic',
  props: {
    title: String,
    newsTypeId: String
},
  setup(__props) {

const router = useRouter()
const props = __props
const { title,newsTypeId } = toRefs(props)
let dataList = ref([]) as any
let param = {
    themeId: newsTypeId?.value,
    typeName: title?.value
}
const showDetail = (item:any) => {
    router.push({
        path: '/news-detail',
        query:{
            id: item.id
        }
    })
}
const toNewsList = () => {
    let param = {
        themeId: newsTypeId?.value,
        typeName: title?.value
    }
    router.push({
        path: '/news-list',
        query: param
    })
}
const init = async() => {
    const res = await getNewsContentList(param) as any

    const result = res.result?.records || []
    if(result.length > 4){
        dataList.value = result.slice(0,4)
    }else{
        dataList.value = result
    }
}
init()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, [
      _createElementVNode("a", { onClick: toNewsList }, [...(_cache[0] || (_cache[0] = [
        _createTextVNode("查看更多", -1),
        _createElementVNode("i", { class: "leftAndright" }, null, -1)
      ]))]),
      _createElementVNode("span", null, _toDisplayString(_unref(title)), 1)
    ]),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          onClick: ($event: any) => (showDetail(item))
        }, _toDisplayString(item.title), 9, _hoisted_2))
      }), 128))
    ])
  ], 64))
}
}

})